// extracted by mini-css-extract-plugin
module.exports = {"comp-wrapper":"comp-wrapper_b91a","revogrid":"revogrid_b4d4","header-wrapper":"header-wrapper_7c27","tips":"tips_2938","info":"info_1548"};